// src/enums/enums.ts
var YotpoPriority = /* @__PURE__ */ ((YotpoPriority2) => {
  YotpoPriority2["primary"] = "primary";
  YotpoPriority2["secondary"] = "secondary";
  YotpoPriority2["tertiary"] = "tertiary";
  return YotpoPriority2;
})(YotpoPriority || {});
var YotpoSize = /* @__PURE__ */ ((YotpoSize2) => {
  YotpoSize2["tiny"] = "tiny";
  YotpoSize2["small"] = "small";
  YotpoSize2["medium"] = "medium";
  YotpoSize2["large"] = "large";
  return YotpoSize2;
})(YotpoSize || {});
var YotpoTypographySize = /* @__PURE__ */ ((YotpoTypographySize2) => {
  YotpoTypographySize2["small"] = "small";
  YotpoTypographySize2["medium"] = "medium";
  YotpoTypographySize2["large"] = "large";
  return YotpoTypographySize2;
})(YotpoTypographySize || {});
var YotpoColor = /* @__PURE__ */ ((YotpoColor2) => {
  YotpoColor2["brand"] = "brand";
  YotpoColor2["destructive"] = "destructive";
  YotpoColor2["premium"] = "premium";
  YotpoColor2["dark"] = "dark";
  YotpoColor2["primary"] = "primary";
  YotpoColor2["disabled"] = "disabled";
  YotpoColor2["light"] = "light";
  return YotpoColor2;
})(YotpoColor || {});
var YotpoSMSPreviewMessageSource = /* @__PURE__ */ ((YotpoSMSPreviewMessageSource2) => {
  YotpoSMSPreviewMessageSource2["left"] = "left";
  YotpoSMSPreviewMessageSource2["right"] = "right";
  return YotpoSMSPreviewMessageSource2;
})(YotpoSMSPreviewMessageSource || {});
var YotpoSMSMessageType = /* @__PURE__ */ ((YotpoSMSMessageType2) => {
  YotpoSMSMessageType2["sms"] = "sms";
  YotpoSMSMessageType2["mms"] = "mms";
  return YotpoSMSMessageType2;
})(YotpoSMSMessageType || {});
var YotpoSmsPreviewSize = /* @__PURE__ */ ((YotpoSmsPreviewSize2) => {
  YotpoSmsPreviewSize2["small"] = "small";
  YotpoSmsPreviewSize2["medium"] = "medium";
  YotpoSmsPreviewSize2["large"] = "large";
  return YotpoSmsPreviewSize2;
})(YotpoSmsPreviewSize || {});
var YotpoProductLogoBackGroundColor = /* @__PURE__ */ ((YotpoProductLogoBackGroundColor2) => {
  YotpoProductLogoBackGroundColor2["white"] = "white";
  YotpoProductLogoBackGroundColor2["gray"] = "gray";
  return YotpoProductLogoBackGroundColor2;
})(YotpoProductLogoBackGroundColor || {});
var YotpoDirection = /* @__PURE__ */ ((YotpoDirection2) => {
  YotpoDirection2["top"] = "top";
  YotpoDirection2["right"] = "right";
  YotpoDirection2["bottom"] = "bottom";
  YotpoDirection2["left"] = "left";
  return YotpoDirection2;
})(YotpoDirection || {});
var YotpoPresentationComponents = /* @__PURE__ */ ((YotpoPresentationComponents2) => {
  YotpoPresentationComponents2["tooltip"] = "tooltip";
  YotpoPresentationComponents2["label"] = "label";
  return YotpoPresentationComponents2;
})(YotpoPresentationComponents || {});
var YotpoPlacement = /* @__PURE__ */ ((YotpoPlacement2) => {
  YotpoPlacement2["center"] = "center";
  YotpoPlacement2["start"] = "start";
  YotpoPlacement2["end"] = "end";
  return YotpoPlacement2;
})(YotpoPlacement || {});
var YotpoEvents = /* @__PURE__ */ ((YotpoEvents2) => {
  YotpoEvents2["show"] = "yotpo-show";
  YotpoEvents2["hide"] = "yotpo-hide";
  YotpoEvents2["change"] = "yotpo-change";
  YotpoEvents2["clear"] = "yotpo-clear";
  YotpoEvents2["input"] = "yotpo-input";
  YotpoEvents2["focus"] = "yotpo-focus";
  YotpoEvents2["blur"] = "yotpo-blur";
  YotpoEvents2["select"] = "yotpo-select";
  YotpoEvents2["tooltipAction"] = "yotpo-tooltip-action";
  YotpoEvents2["requestChange"] = "yotpo-request-change";
  YotpoEvents2["requestClose"] = "yotpo-request-close";
  YotpoEvents2["mainAction"] = "yotpo-main-action";
  YotpoEvents2["secondaryAction"] = "yotpo-secondary-action";
  YotpoEvents2["linkAction"] = "yotpo-link-action";
  YotpoEvents2["remove"] = "yotpo-remove";
  YotpoEvents2["settings"] = "yotpo-settings";
  YotpoEvents2["pageSelect"] = "yotpo-page-select";
  YotpoEvents2["smsPreviewAction"] = "yotpo-sms-preview-action";
  YotpoEvents2["pageHeaderSubtitleAction"] = "yotpo-page-header-subtitle-action";
  YotpoEvents2["cancel"] = "yotpo-cancel";
  YotpoEvents2["back"] = "yotpo-back";
  YotpoEvents2["pageHeaderTitleEditAction"] = "yotpo-page-header-title-edit-action";
  YotpoEvents2["scrollEnd"] = "yotpo-scroll-end";
  return YotpoEvents2;
})(YotpoEvents || {});
var YotpoUnderline = /* @__PURE__ */ ((YotpoUnderline2) => {
  YotpoUnderline2["none"] = "none";
  YotpoUnderline2["hover"] = "hover";
  YotpoUnderline2["always"] = "always";
  return YotpoUnderline2;
})(YotpoUnderline || {});
var YotpoInputType = /* @__PURE__ */ ((YotpoInputType2) => {
  YotpoInputType2["text"] = "text";
  YotpoInputType2["date"] = "date";
  YotpoInputType2["email"] = "email";
  YotpoInputType2["number"] = "number";
  YotpoInputType2["password"] = "password";
  YotpoInputType2["search"] = "search";
  YotpoInputType2["tel"] = "tel";
  YotpoInputType2["url"] = "url";
  YotpoInputType2["color"] = "color";
  YotpoInputType2["datetimeLocal"] = "datetime-local";
  YotpoInputType2["time"] = "time";
  YotpoInputType2["month"] = "month";
  YotpoInputType2["week"] = "week";
  return YotpoInputType2;
})(YotpoInputType || {});
var YotpoHeightResizing = /* @__PURE__ */ ((YotpoHeightResizing2) => {
  YotpoHeightResizing2["fixed"] = "fixed";
  YotpoHeightResizing2["expand"] = "expand";
  YotpoHeightResizing2["resize"] = "resize";
  return YotpoHeightResizing2;
})(YotpoHeightResizing || {});
var YotpoSpreadDirection = /* @__PURE__ */ ((YotpoSpreadDirection2) => {
  YotpoSpreadDirection2["vertical"] = "vertical";
  YotpoSpreadDirection2["horizontal"] = "horizontal";
  return YotpoSpreadDirection2;
})(YotpoSpreadDirection || {});
var YotpoSpacing = /* @__PURE__ */ ((YotpoSpacing2) => {
  YotpoSpacing2["none"] = "none";
  YotpoSpacing2["small"] = "small";
  YotpoSpacing2["medium"] = "medium";
  YotpoSpacing2["large"] = "large";
  return YotpoSpacing2;
})(YotpoSpacing || {});
var YotpoPriorityTheme = /* @__PURE__ */ ((YotpoPriorityTheme2) => {
  YotpoPriorityTheme2["lightPrimary"] = "light-primary";
  YotpoPriorityTheme2["lightSecondary"] = "light-secondary";
  YotpoPriorityTheme2["darkPrimary"] = "dark-primary";
  YotpoPriorityTheme2["darkSecondary"] = "dark-secondary";
  return YotpoPriorityTheme2;
})(YotpoPriorityTheme || {});
var YotpoStatus = /* @__PURE__ */ ((YotpoStatus2) => {
  YotpoStatus2["neutral"] = "neutral";
  YotpoStatus2["primary"] = "primary";
  YotpoStatus2["warning"] = "warning";
  YotpoStatus2["danger"] = "danger";
  YotpoStatus2["success"] = "success";
  YotpoStatus2["premium"] = "premium";
  return YotpoStatus2;
})(YotpoStatus || {});
var YotpoTrigger = /* @__PURE__ */ ((YotpoTrigger2) => {
  YotpoTrigger2["click"] = "click";
  YotpoTrigger2["hover"] = "hover";
  YotpoTrigger2["focus"] = "focus";
  YotpoTrigger2["manual"] = "manual";
  return YotpoTrigger2;
})(YotpoTrigger || {});
var YotpoCollapsible = /* @__PURE__ */ ((YotpoCollapsible2) => {
  YotpoCollapsible2["icon"] = "icon";
  YotpoCollapsible2["textAndIcon"] = "text-and-icon";
  YotpoCollapsible2["none"] = "none";
  return YotpoCollapsible2;
})(YotpoCollapsible || {});
var YotpoProducts = /* @__PURE__ */ ((YotpoProducts2) => {
  YotpoProducts2["reviews"] = "Reviews";
  YotpoProducts2["vugc"] = "Vugc";
  YotpoProducts2["loyalty"] = "Loyalty";
  YotpoProducts2["referrals"] = "Referrals";
  YotpoProducts2["smsbump"] = "Smsbump";
  YotpoProducts2["email"] = "Email";
  YotpoProducts2["insights"] = "Insights";
  YotpoProducts2["subscriptions"] = "Subscriptions";
  return YotpoProducts2;
})(YotpoProducts || {});
var YotpoModalWidth = /* @__PURE__ */ ((YotpoModalWidth2) => {
  YotpoModalWidth2["default"] = "default";
  YotpoModalWidth2["medium"] = "medium";
  YotpoModalWidth2["large"] = "large";
  return YotpoModalWidth2;
})(YotpoModalWidth || {});
var YotpoFooterAction = /* @__PURE__ */ ((YotpoFooterAction2) => {
  YotpoFooterAction2["all"] = "all";
  YotpoFooterAction2["main"] = "main";
  YotpoFooterAction2["none"] = "none";
  return YotpoFooterAction2;
})(YotpoFooterAction || {});
var YotpoFooterType = /* @__PURE__ */ ((YotpoFooterType2) => {
  YotpoFooterType2["positive"] = "positive";
  YotpoFooterType2["negative"] = "negative";
  YotpoFooterType2["premium"] = "premium";
  return YotpoFooterType2;
})(YotpoFooterType || {});
var YotpoModalCloseTrigger = /* @__PURE__ */ ((YotpoModalCloseTrigger2) => {
  YotpoModalCloseTrigger2["closeButton"] = "close-button";
  YotpoModalCloseTrigger2["keyboard"] = "keyboard";
  YotpoModalCloseTrigger2["overlay"] = "overlay";
  return YotpoModalCloseTrigger2;
})(YotpoModalCloseTrigger || {});
var YotpoButtonType = /* @__PURE__ */ ((YotpoButtonType2) => {
  YotpoButtonType2["button"] = "button";
  YotpoButtonType2["submit"] = "submit";
  return YotpoButtonType2;
})(YotpoButtonType || {});
var YotpoCollapsibleIcon = /* @__PURE__ */ ((YotpoCollapsibleIcon2) => {
  YotpoCollapsibleIcon2["chevronDownSmall"] = "chevron-down-small";
  YotpoCollapsibleIcon2["chevronUpSmall"] = "chevron-up-small";
  YotpoCollapsibleIcon2["chevronUpBig"] = "chevron-up-big";
  YotpoCollapsibleIcon2["chevronDownBig"] = "chevron-down-big";
  return YotpoCollapsibleIcon2;
})(YotpoCollapsibleIcon || {});
var YotpoGridMargins = /* @__PURE__ */ ((YotpoGridMargins2) => {
  YotpoGridMargins2["none"] = "none";
  YotpoGridMargins2["container"] = "container";
  YotpoGridMargins2["page"] = "page";
  return YotpoGridMargins2;
})(YotpoGridMargins || {});
var YotpoProgressRingContent = /* @__PURE__ */ ((YotpoProgressRingContent2) => {
  YotpoProgressRingContent2["percentage"] = "percentage";
  YotpoProgressRingContent2["counter"] = "counter";
  YotpoProgressRingContent2["none"] = "none";
  YotpoProgressRingContent2["icon"] = "icon";
  return YotpoProgressRingContent2;
})(YotpoProgressRingContent || {});
var YotpoProgressContent = /* @__PURE__ */ ((YotpoProgressContent2) => {
  YotpoProgressContent2["percentage"] = "percentage";
  YotpoProgressContent2["counter"] = "counter";
  YotpoProgressContent2["none"] = "none";
  return YotpoProgressContent2;
})(YotpoProgressContent || {});
var YotpoProgressRingStatusIcon = /* @__PURE__ */ ((YotpoProgressRingStatusIcon2) => {
  YotpoProgressRingStatusIcon2["neutral"] = "check";
  YotpoProgressRingStatusIcon2["primary"] = "check";
  YotpoProgressRingStatusIcon2["warning"] = "alert";
  YotpoProgressRingStatusIcon2["danger"] = "alert-circle";
  YotpoProgressRingStatusIcon2["success"] = "check";
  YotpoProgressRingStatusIcon2["premium"] = "check";
  return YotpoProgressRingStatusIcon2;
})(YotpoProgressRingStatusIcon || {});
var YotpoProgressBarStatusIcon = /* @__PURE__ */ ((YotpoProgressBarStatusIcon2) => {
  YotpoProgressBarStatusIcon2["neutral"] = "check-circle";
  YotpoProgressBarStatusIcon2["primary"] = "check-circle";
  YotpoProgressBarStatusIcon2["warning"] = "alert";
  YotpoProgressBarStatusIcon2["danger"] = "alert-circle";
  YotpoProgressBarStatusIcon2["success"] = "check-circle";
  YotpoProgressBarStatusIcon2["premium"] = "check-circle";
  return YotpoProgressBarStatusIcon2;
})(YotpoProgressBarStatusIcon || {});
var YotpoIconLibraryType = /* @__PURE__ */ ((YotpoIconLibraryType2) => {
  YotpoIconLibraryType2["source"] = "source";
  YotpoIconLibraryType2["url"] = "url";
  return YotpoIconLibraryType2;
})(YotpoIconLibraryType || {});
var YotpoLogoColor = /* @__PURE__ */ ((YotpoLogoColor2) => {
  YotpoLogoColor2["blue"] = "blue";
  YotpoLogoColor2["white"] = "white";
  return YotpoLogoColor2;
})(YotpoLogoColor || {});
var YotpoTagSize = /* @__PURE__ */ ((YotpoTagSize2) => {
  YotpoTagSize2["small"] = "small";
  YotpoTagSize2["medium"] = "medium";
  return YotpoTagSize2;
})(YotpoTagSize || {});
var YotpoSpinnerRingSize = /* @__PURE__ */ ((YotpoSpinnerRingSize2) => {
  YotpoSpinnerRingSize2["small"] = "small";
  YotpoSpinnerRingSize2["medium"] = "medium";
  YotpoSpinnerRingSize2["large"] = "large";
  return YotpoSpinnerRingSize2;
})(YotpoSpinnerRingSize || {});
var YotpoAddItemSize = /* @__PURE__ */ ((YotpoAddItemSize2) => {
  YotpoAddItemSize2["medium"] = "medium";
  YotpoAddItemSize2["large"] = "large";
  return YotpoAddItemSize2;
})(YotpoAddItemSize || {});
var YotpoAddItemType = /* @__PURE__ */ ((YotpoAddItemType2) => {
  YotpoAddItemType2["regular"] = "regular";
  YotpoAddItemType2["dashed"] = "dashed";
  return YotpoAddItemType2;
})(YotpoAddItemType || {});
var YotpoAlignment = /* @__PURE__ */ ((YotpoAlignment2) => {
  YotpoAlignment2["left"] = "left";
  YotpoAlignment2["center"] = "center";
  YotpoAlignment2["right"] = "right";
  return YotpoAlignment2;
})(YotpoAlignment || {});
var YotpoStepperItemStatus = /* @__PURE__ */ ((YotpoStepperItemStatus2) => {
  YotpoStepperItemStatus2["uncompleted"] = "uncompleted";
  YotpoStepperItemStatus2["active"] = "active";
  YotpoStepperItemStatus2["completed"] = "completed";
  YotpoStepperItemStatus2["disabled"] = "disabled";
  return YotpoStepperItemStatus2;
})(YotpoStepperItemStatus || {});
var YotpoTableCellSize = /* @__PURE__ */ ((YotpoTableCellSize2) => {
  YotpoTableCellSize2["tiny"] = "tiny";
  YotpoTableCellSize2["small"] = "small";
  YotpoTableCellSize2["medium"] = "medium";
  YotpoTableCellSize2["large"] = "large";
  YotpoTableCellSize2["stretch"] = "stretch";
  return YotpoTableCellSize2;
})(YotpoTableCellSize || {});
var YotpoTableRowSize = /* @__PURE__ */ ((YotpoTableRowSize2) => {
  YotpoTableRowSize2["medium"] = "medium";
  YotpoTableRowSize2["large"] = "large";
  return YotpoTableRowSize2;
})(YotpoTableRowSize || {});
var YotpoFileUploadType = /* @__PURE__ */ ((YotpoFileUploadType2) => {
  YotpoFileUploadType2["file"] = "file";
  YotpoFileUploadType2["image"] = "image";
  return YotpoFileUploadType2;
})(YotpoFileUploadType || {});
var YotpoListFontItemFont = /* @__PURE__ */ ((YotpoListFontItemFont2) => {
  YotpoListFontItemFont2["lato"] = "Lato";
  YotpoListFontItemFont2["nunitoSans"] = "Nunito Sans";
  YotpoListFontItemFont2["lora"] = "Lora";
  YotpoListFontItemFont2["montserrat"] = "Montserrat";
  YotpoListFontItemFont2["openSans"] = "Open Sans";
  YotpoListFontItemFont2["oswald"] = "Oswald";
  YotpoListFontItemFont2["ptSerif"] = "PT Serif";
  YotpoListFontItemFont2["raleway"] = "Raleway";
  YotpoListFontItemFont2["robotoSlab"] = "Roboto Slab";
  YotpoListFontItemFont2["roboto"] = "Roboto";
  YotpoListFontItemFont2["sourceSansPro"] = "Source Sans Pro";
  YotpoListFontItemFont2["workSans"] = "Work Sans";
  return YotpoListFontItemFont2;
})(YotpoListFontItemFont || {});
var YotpoColorPickerVisualStyle = /* @__PURE__ */ ((YotpoColorPickerVisualStyle2) => {
  YotpoColorPickerVisualStyle2["input"] = "input";
  YotpoColorPickerVisualStyle2["button"] = "button";
  return YotpoColorPickerVisualStyle2;
})(YotpoColorPickerVisualStyle || {});
var YotpoColorFormat = /* @__PURE__ */ ((YotpoColorFormat2) => {
  YotpoColorFormat2["hex"] = "hex";
  YotpoColorFormat2["rgb"] = "rgb";
  YotpoColorFormat2["hsl"] = "hsl";
  return YotpoColorFormat2;
})(YotpoColorFormat || {});
var YotpoGridAlignment = /* @__PURE__ */ ((YotpoGridAlignment2) => {
  YotpoGridAlignment2["none"] = "none";
  YotpoGridAlignment2["start"] = "start";
  YotpoGridAlignment2["center"] = "center";
  YotpoGridAlignment2["end"] = "end";
  return YotpoGridAlignment2;
})(YotpoGridAlignment || {});
export {
  YotpoAddItemSize,
  YotpoAddItemType,
  YotpoAlignment,
  YotpoButtonType,
  YotpoCollapsible,
  YotpoCollapsibleIcon,
  YotpoColor,
  YotpoColorFormat,
  YotpoColorPickerVisualStyle,
  YotpoDirection,
  YotpoEvents,
  YotpoFileUploadType,
  YotpoFooterAction,
  YotpoFooterType,
  YotpoGridAlignment,
  YotpoGridMargins,
  YotpoHeightResizing,
  YotpoIconLibraryType,
  YotpoInputType,
  YotpoListFontItemFont,
  YotpoLogoColor,
  YotpoModalCloseTrigger,
  YotpoModalWidth,
  YotpoPlacement,
  YotpoPresentationComponents,
  YotpoPriority,
  YotpoPriorityTheme,
  YotpoProductLogoBackGroundColor,
  YotpoProducts,
  YotpoProgressBarStatusIcon,
  YotpoProgressContent,
  YotpoProgressRingContent,
  YotpoProgressRingStatusIcon,
  YotpoSMSMessageType,
  YotpoSMSPreviewMessageSource,
  YotpoSize,
  YotpoSmsPreviewSize,
  YotpoSpacing,
  YotpoSpinnerRingSize,
  YotpoSpreadDirection,
  YotpoStatus,
  YotpoStepperItemStatus,
  YotpoTableCellSize,
  YotpoTableRowSize,
  YotpoTagSize,
  YotpoTrigger,
  YotpoTypographySize,
  YotpoUnderline
};
